// extracted by mini-css-extract-plugin
module.exports = {"table":"Table-module--table--3C6Tf","tableWrapper":"Table-module--tableWrapper--3CVOA","textGreen":"Table-module--textGreen--yE710"};